import { useT } from '../lib/i18n';

interface Props {
  title: string;
  /** The consequence of going ahead, spelled out. */
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * A blocking confirmation for actions that cannot be taken back.
 *
 * The message says what will happen rather than asking "are you sure": a
 * player who is told the match is about to be settled on the current score
 * can make a decision, whereas one asked to confirm can only guess.
 */
export function ConfirmDialog({ title, message, confirmLabel, onConfirm, onCancel }: Props) {
  const t = useT();

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/80 p-4">
      <div className="panel flex max-h-[calc(100dvh-2rem)] w-full max-w-sm flex-col gap-4 overflow-y-auto">
        <h2 className="text-lg font-black">{title}</h2>
        <p className="min-h-[3.75rem] shrink-0 text-sm text-white/70">{message}</p>
        <div className="flex shrink-0 items-stretch gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="btn-ghost min-w-0 flex-1 whitespace-normal"
          >
            {t('common.cancel')}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="btn min-w-0 flex-1 whitespace-normal bg-ball-red px-4"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
